/**
 *
 * MainLayout
 *
 */

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose, Dispatch } from 'redux';
import React, { FC, lazy, PropsWithChildren, Suspense } from 'react';

import injectSaga from 'utils/injectSaga';
import injectReducer from 'utils/injectReducer';
import {
  selectMainLayoutShell,
  selectPendingApprovalMode,
  selectCountPendingOrder,
  selectBuyerWebVersion,
  selectMainLayoutRegion,
} from './selectors';
import reducer from './reducer';
import saga from './saga';
import {
  sideNavToggle,
  signout,
  setLang,
  notificationRegisterTokenAction,
  setSearchProductResults,
  buyerWebVersion,
  setOpenSigninPopup,
  openSelectStoreModal,
} from './actions';
import { RootState, IMainLayoutShellStateProps, IMainLayoutDispatchProps } from './types';
import { NotificationRegisterInput } from 'types/schema';
import { replace } from 'redux-first-history';
import LoadingIndicator from 'components/LoadingIndicator';

const MainLayout = lazy(() => import(/* webpackPreload: true */ 'components/MainLayout'));

const mapStateToProps = createStructuredSelector<RootState, IMainLayoutShellStateProps>({
  mainLayout: selectMainLayoutShell,
  isPenddingApproval: selectPendingApprovalMode(),
  countPendingOrder: selectCountPendingOrder(),
  buyerWebVersion: selectBuyerWebVersion(),
  region: selectMainLayoutRegion(),
});

function mapDispatchToProps(dispatch: Dispatch): IMainLayoutDispatchProps {
  return {
    dispatch: dispatch,
    toggleSideNav: () => dispatch(sideNavToggle()),
    signout: () => dispatch(signout()),
    setLang: (data: any) => dispatch(setLang(data)),
    registerNotificationToken: (input: NotificationRegisterInput) => {
      dispatch(notificationRegisterTokenAction(input));
    },
    goHome: () => dispatch(replace('/')),
    setSearchProductResults: (payload: any) => dispatch(setSearchProductResults.request(payload)),
    clearSearchProductResults: () => dispatch(setSearchProductResults.success({})),
    fetchBuyerWebVersion: () => dispatch(buyerWebVersion()),
    onOpenSigninPopup: (value) => dispatch(setOpenSigninPopup(value)),
    onOpenSelectStore: () => dispatch(openSelectStoreModal() as any),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withReducer = injectReducer({ key: 'main', reducer: reducer });
const withSaga = injectSaga({ key: 'main', saga: saga });

const MainLayoutContainer = compose(
  withReducer,
  withSaga,
  withConnect,
)((props) => (
  <Suspense fallback={<LoadingIndicator />}>
    <MainLayout {...props} />
  </Suspense>
)) as FC<PropsWithChildren<unknown>>;

export default MainLayoutContainer;
